module.exports = __webpack_public_path__ + "static/media/Historial_de_llamadas.d04f8790.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/Historial_de_llamadas.svg
// module id = 1859
// module chunks = 0